import StoresManagerVue from '@/views/sic/stores-manager/stores-manager.vue';

const basePath = '/sic/stores-manager';
const role = 'sic'; // 角色身份

export const SIC_STORES_MANAGER_INDEX = 'sic-stores-manager-index';
export const SIC_STORES_MANAGER_EDIT_SA = 'sic-sotres-manager-edit-sa';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: StoresManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_STORES_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "stores-manager" */
        `@/views/${role}/stores-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/editSa/:id`,
      name: SIC_STORES_MANAGER_EDIT_SA,
      props: true,
      component: () => import(
        /* webpackChunkName: "stores-manager-edit-sa" */
        `@/views/${role}/stores-manager/editSa.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
